/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const ReceiverIdColumnFormatter = (cellContent, row, rowIndex) => {
  const { receiverId } = row;

  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {receiverId ? receiverId : `-`}
      </div>
      <> </>
    </>
  );
};
